import { Layers } from 'lucide-react'
import { cn } from '@/lib/cn'
import type { Job } from '@/types'

/**
 * Work a section began and could not finish: the pieces it still owes on a job
 * it keeps. Nothing renders when there is no balance, so this can be dropped in
 * unconditionally beside UrgentBadge.
 *
 * A balance is why the job is at the top of the section's queue, so the badge
 * says the count rather than just the word - the operator needs to know they
 * are picking up 50 pieces, not another 100.
 */
export default function BalanceBadge({
  balance,
  className,
}: {
  balance?: Job['balance']
  className?: string
}) {
  if (!balance || balance.remaining <= 0) return null

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border border-warning/60 bg-warning/20 px-2 py-0.5 text-2xs font-bold uppercase tracking-wide text-warning',
        className,
      )}
      title={`${balance.done} of ${balance.pieces} pcs finished, ${balance.remaining} left at this section`}
    >
      <Layers className="size-3" />
      {balance.remaining}/{balance.pieces} left
    </span>
  )
}
